<script>
    import { t } from "../../../../i18n";

    export let data = {};

    let rows = data.restaurants;

    let canRender = function(row){
        return !!row;
    };

    let rand = (min,max) => Math.floor(Math.random() * max) + min;
    let buildBadge = function(row, tr){
        let status = (row||{}).status||{};
        switch(status.id){
            case 2:     return `<div class="badge badge-info mr-1 mb-1">${status.txt||tr('badge.waiting_list')}</div>`;
            case 3:     return `<div class="badge badge-danger mr-1 mb-1">${status.txt||tr('badge.no_availability')}</div>`;
            case 4:     return `<div class="badge badge-success mr-1 mb-1">${status.txt||tr('badge.confirmed')}</div>`;
            case 6:     return `<div class="badge badge-danger mr-1 mb-1">${status.txt||tr('badge.canceled')}</div>`;
            default:    return `<div class="badge badge-warning mr-1 mb-1">${tr('badge.on_request')}</div>`;
        }
    };


    let showPopup = function(title, content){
        if(!window || !window.Swal) return alert(content);
        window.Swal.fire({
                title: title,
                html: content,
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
            }
        );
    };
</script>


<style>
    :global(.swal2-container .swal2-content .menu-item)   { text-align:left; border-bottom: 1px solid #ededed; }
    :global(.swal2-container .swal2-content .menu-item label)  {  display: block; font-weight: bold; margin-top: 32px; font-family: "Rubik", Helvetica, Arial, serif; font-size: .96em; color: #595959; }
</style>

<div class="table-responsive">
    <table class="table mb-0">
        <thead class="thead-dark">
        <tr>
            <th>{$t('restaurants.day')}</th>
            <th>{$t('restaurants.name')}</th>
            <th>{$t('restaurants.status')}</th>
        </tr>
        </thead>
        <tbody>
            {#each rows as row}
            {#if canRender(row)}
            <tr>
                <td>{$t('common.day_n', {n: row.day})}</td>
                <td title="{row.menu||''}">
                    {#if (row.menu && row.menu.length)}
                        <i class="bx bx-restaurant align-middle" style="cursor:pointer;" on:click={()=>showPopup($t('restaurants.menu_of', {name: row.name, day: row.day}), row.menu)}></i> -
                    {/if}

                    {row.name}

                </td>
                <td>{@html buildBadge(row, $t)}</td>
            </tr>
            {/if}
            {/each}

        </tbody>
    </table>
</div>